/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1CustomMethodEnum = {
    SelfDefined: 'self_defined',
    Compatible: 'compatible'
};
/**
 * Check if a given object implements the InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1Custom interface.
 */
export function instanceOfInternalAdminWhitelabelRequestV4SslCertificateDataOneOf1Custom(value) {
    if (!('privateKey' in value) || value['privateKey'] === undefined)
        return false;
    if (!('certificate' in value) || value['certificate'] === undefined)
        return false;
    if (!('method' in value) || value['method'] === undefined)
        return false;
    return true;
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1CustomFromJSON(json) {
    return InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1CustomFromJSONTyped(json, false);
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1CustomFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'privateKey': json['private_key'],
        'certificate': json['certificate'],
        'method': json['method'],
    };
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1CustomToJSON(json) {
    return InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1CustomToJSONTyped(json, false);
}
export function InternalAdminWhitelabelRequestV4SslCertificateDataOneOf1CustomToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'private_key': value['privateKey'],
        'certificate': value['certificate'],
        'method': value['method'],
    };
}
